import { modelingApi } from '@/api';
import { Label, VFlex, useVModal } from '@/package';

type ModelingDetailAliasEditorProps = {
  alias: string;
  onChangeAlias(alias: string): void;
};

const ModelingDetailAliasEditor = ({
  alias,
  onChangeAlias,
}: ModelingDetailAliasEditorProps) => {
  const { openPrompt } = useVModal();
  const onAliasClick = () => {
    openPrompt({
      title: 'Apply alias',
      promptMessage: 'The model is applied only when an alias is entered.',
      inputProps: {
        label: 'Alias',
        defaultValue: alias ?? '',
        maxLength: 100,
      },
      confirmText: 'Apply',
      async onConfirm(event) {
        const newAlias = event.target.value;

        if (!newAlias || newAlias === alias) return onChangeAlias(newAlias);

        const {
          data: { resultData: count },
        } = await modelingApi.getCount({ alias: event.target.value });

        count > 0 ? event.preventDefault() : onChangeAlias(newAlias);
      },
    });
  };

  return (
    <VFlex
      role="button"
      onClick={e => {
        e.stopPropagation();
        onAliasClick();
      }}
      className="text-body-md"
      gap={0.25}
      items="center"
    >
      {alias ? <Label className="size-[14px] text-blue-300" /> : null}
      <div>{alias ? alias : 'No alias'}</div>
    </VFlex>
  );
};

ModelingDetailAliasEditor.displayName = 'ModelingDistinctAliasChecker';

export default ModelingDetailAliasEditor;
